module.exports = __webpack_public_path__ + "static/media/hospital.7cd24d02.png";